<template>
  <div @click="handler" tag="div" class="item flex">
    <div class="ava flex0 mr10">
      <img class="radius50" :src="info|DocAva" alt="" @error="__docError">
      <div v-if="info.docCcpRole" class="tac pt5">
        <span :class="['ccp-tag','ccp-tag'+info.docCcpRole]"></span>
      </div>
    </div>
    <div class="info flex1">
      <h3><span class="color_333 fs16">{{ info.docName }}</span> <font v-if="info.docScoure"
                                                                       class="iconfont fs12 orange">
        &#xe664;</font> <span
        class="fs12 orange">{{ info.docScoure ? info.docScoure + '分' : '' }}</span></h3>
      <div class="color_666 mt5 fs14">{{ info.docDeptName }}<span v-html="renderDocTitleHtml(info)"></span></div>
      <div class="color_666 mt5">{{ info.docHosName }}</div>
      <div class="mt5 color_999 skill">擅长：{{ info.docSkill }}</div>
      <doc-services :info="info" class="mt5"></doc-services>
      <p class="mt15">
        <span
          class="fs13 color_main border radius5 pt2 pb3 pl5 pr5"
          v-if="info.consultAvgReplyTimeDescription">平均响应时间：{{ info.consultAvgReplyTimeDescription }}</span>
        <span
          class="fs13 color_main border radius5 pt2 pb3 pl5 pr5" v-if="info.prescriptionStatus">可开处方</span>
      </p>
    </div>
  </div>
</template>

<script>
import DocAva from '../../utils/docAva'
import {avaErrorMixin} from "../../lib/mixin";
import DocServices from "../../page/group/components/doc-services";
import {docTitleMixin} from "@/page/doc/lib";
import {isAlipay, isDev, isDevelopment, isWeixin} from "@/lib/util";

export default {
  name: 'common-doc-list-item',
  props: {
    info: Object,
    toDocCard: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      team: null
    };
  },
  computed: {},
  filters: {DocAva},
  components: {DocServices},
  mixins: [avaErrorMixin, docTitleMixin],
  created() {
    this.getDetail()
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    handler() {
      if (this.toDocCard) {
        if (isWeixin() || isAlipay() || isDevelopment()) this.$router.push({
          path: '/onlineDoctorCard',
          query: {docId: this.info.docId, ...this.$route.query}
        });
        else this.doNativeAction('tynet://nethos.doc.card?id=' + this.info.docId);
      } else {
        this.$emit('click', this.info);
      }
    },
    async getDetail() {

    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/public";
@import "~@/page/doc/doc.scss";

.border {
  border-color: $mainColor;
}

.orange {
  color: orange;
}

.item {
  padding: 15px;
}

.item + .item {
  @include border(top);
}

.ava {
  @include w_h(60px, 60px);

  img {
    @include w_h(60px, 60px);
  }
}

.info {
  line-height: 1.2;
}

.skill {
  @include lines(2);
}

.state {
  img {
    height: px2rem(15px);
  }

  li {
    align-items: center;
    display: flex;

    div {
      word-break: break-word;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/consult/doc-item.vue